import React from 'react';
import { apiPost } from './../helper/helperApi';
import { handleException } from './../helper/helperError';
import { onAuthStateChanged } from 'firebase/auth';
import { getAuth } from '../helper/helperFirebaseAuth';


const UserContext = React.createContext();


export const AuthProvider = ({ children }) => {
    const [authUser, setAuthUser] = React.useState(null);
    const [authUserEx, setAuthUserEx] = React.useState(null);
    const [authLoading, setAuthLoading] = React.useState(true);
    const refreshUserProfile = React.useCallback()


    const handleStateChange = async (currentUser) => {
        try {
            setAuthLoading(true);
            setAuthUser(currentUser);
            if (currentUser) {
                const response = await apiPost("/auth/getUserProfile");
                setAuthUserEx(response.data);
            } else {
                setAuthUserEx(null);
            }
            setAuthLoading(false);
        } catch (ex) {
            handleException(ex, 'User Profile Error', "There was an error fetching user profile. Please try again later.");
            setAuthUserEx(null);
            auth.signOut();
        }
    }

    React.useEffect(() => {
        // START: Listen for auth state changes
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, handleStateChange);

        // END: Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);

    return (
        <UserContext.Provider value={{ authUser, authUserEx, authLoading, refreshUserProfile }}>
            {children}
        </UserContext.Provider>
    );
};

export const useAuth = () => React.useContext(UserContext);